import { mergeFilterUpdate } from '#/modules/commonComponents/table/listFilterKeys';

export const BASE_QTY_GT_ZERO = '0';

export function parseOptionalQty(value) {
  if (value === undefined || value === null || value === '') {
    return null;
  }
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return null;
  }
  return n;
}

export function isBaseQtyGtActive(value) {
  return value === BASE_QTY_GT_ZERO || value === 0;
}

/**
 * 摘要字串：觸發鈕／chip。
 * @returns {string|null} null＝無篩選
 */
export function formatQtyFilterSummary({ baseQtyGt, baseQtyMin, baseQtyMax } = {}) {
  const parts = [];
  if (isBaseQtyGtActive(baseQtyGt)) {
    parts.push('> 0');
  }
  const min = baseQtyMin == null || baseQtyMin === '' ? '' : String(baseQtyMin);
  const max = baseQtyMax == null || baseQtyMax === '' ? '' : String(baseQtyMax);
  if (min && max) {
    parts.push(`${min}～${max}`);
  } else if (min) {
    parts.push(`≥${min}`);
  } else if (max) {
    parts.push(`≤${max}`);
  }
  return parts.length > 0 ? parts.join(' · ') : null;
}

/**
 * 套用數量篩選（互斥：有 min 則清 baseQtyGt）。
 * min > max 時回傳 `{ ok: false, filters }`，呼叫端不寫入 URL。
 */
export function applyQtyFilters(filters, nextQty = {}) {
  const minRaw = nextQty.baseQtyMin ?? '';
  const maxRaw = nextQty.baseQtyMax ?? '';
  const minNum = parseOptionalQty(minRaw);
  const maxNum = parseOptionalQty(maxRaw);

  if (minNum != null && maxNum != null && minNum > maxNum) {
    return { ok: false, filters };
  }

  let next = { ...filters };
  const hasMin = minNum != null;
  const wantGt = isBaseQtyGtActive(nextQty.baseQtyGt) && !hasMin;

  next = mergeFilterUpdate(next, 'baseQtyMin', hasMin ? String(minNum) : undefined);
  next = mergeFilterUpdate(next, 'baseQtyMax', maxNum != null ? String(maxNum) : undefined);
  next = mergeFilterUpdate(next, 'baseQtyGt', wantGt ? BASE_QTY_GT_ZERO : undefined);

  return { ok: true, filters: next };
}
